export const TwitterIcon = () => (
  <svg
    tabIndex={-1}
    focusable="false"
    className="svg-icon icon-twitter"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className="primary-path"
      tabIndex={-1}
      d="M22 5.89305C21.2639 6.21429 20.4741 6.43216 19.6442 6.52942C20.4915 6.02968 21.1402 5.23702 21.4476 4.2954C20.6527 4.75819 19.7754 5.09424 18.8406 5.27641C18.092 4.48989 17.0271 4 15.8461 4C13.5803 4 11.7431 5.80937 11.7431 8.03969C11.7431 8.35601 11.7794 8.66496 11.8494 8.96039C8.44001 8.79174 5.41684 7.18301 3.39347 4.7385C3.03977 5.33425 2.83856 6.02842 2.83856 6.76943C2.83856 8.1714 3.56343 9.40841 4.66324 10.1321C3.99085 10.11 3.35847 9.92782 2.80484 9.62502V9.67549C2.80484 11.6326 4.21958 13.2659 6.09546 13.6376C5.75177 13.7287 5.38935 13.7792 5.01442 13.7792C4.74948 13.7792 4.49327 13.7534 4.24206 13.7041C4.76445 15.3104 6.27919 16.4785 8.07387 16.5105C6.67037 17.5937 4.90069 18.2374 2.97856 18.2374C2.64739 18.2374 2.32118 18.2177 2 18.182C3.81592 19.3304 5.97177 20 8.28883 20C15.8362 20 19.9617 13.8432 19.9617 8.50374L19.9479 7.98063C20.754 7.41439 21.4513 6.70297 22 5.89305Z"
      fill="#27292D"
    />
  </svg>
);
